/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class V1OrderLineCloneRequestFailed {
    'requestId'?: string;
    'userId'?: string;
    'timestamp'?: Date;
    'orgId'?: string;
    'sourceCampaignId'?: string;
    'sourceOrderLineId'?: string;
    'targetCampaignId'?: string;
    'errorMessage'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "requestId",
            "baseName": "request_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "userId",
            "baseName": "user_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceCampaignId",
            "baseName": "source_campaign_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceOrderLineId",
            "baseName": "source_order_line_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "targetCampaignId",
            "baseName": "target_campaign_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "errorMessage",
            "baseName": "error_message",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1OrderLineCloneRequestFailed.attributeTypeMap;
    }

    public constructor() {
    }
}

